module.exports = __webpack_public_path__ + "media/images/icons/icon-t-shirt-3de54b6133d21e32b1e16d773e6101ad.svg";